import { showGoogleStatusModal } from '../../use-integration-management/state'
import { integrationService } from '../../../services/integration/integration-service'
// useI18n burada kullanılamaz
import { responseHandlerService } from '@/plugins/responseHandlerService'
import { checkDuplicateAccount } from './check-duplicate-account'

/**
 * Initiates Google connection flow
 */
export const connectToGoogle = async (t) => {
  
  // Close modal
  showGoogleStatusModal.value = false

  try {
    // Bu aşamada email'i bilemiyoruz, Google yönlendirmesinden sonra kontrol edilecek
    // Email kontrolü backend tarafında da yapılabilir
    
    // Google bağlantısını başlat (Google platform ID is 6)
    await integrationService.connectIntegration(6)
  } catch (error) {
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.googleConnection')
    )
  }
}
